import { v4 as uuidv4 } from 'uuid';
import { ComponentType, type IComponentSchema } from '../../types';
import { ComponentConfigType } from '../../utils/data-parser';
import { JsonFieldType } from '../../../types';
import type { ITreeTableProps } from './helper';

export const generate = (
  props?: Partial<IComponentSchema<ITreeTableProps>>
): IComponentSchema<ITreeTableProps> => {
  const id = uuidv4();

  return {
    type: JsonFieldType.VOID,
    name: props?.name || id,
    title: props?.title || 'Tree Table',
    'x-designable-id': id,
    'x-index': props?.['x-index'] || 0,
    'x-component': ComponentType.TreeTable,
    'x-component-props': {
      columns: {} as any,
      data: [],
      defaultView: 'hierarchical',
      showViewToggle: true,
      childKey: 'data.termId',
      parentKey: 'data.parents[].parent',
      hasChildrenKey: 'data.hasChildren',
      rowItemName: 'row',
    },
    'x-component-props-config': {
      data: {
        type: ComponentConfigType.Variable,
      },
    },
  };
};
